/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './devices-map.scss';

/* eslint-disable import/no-unresolved, import/default, import/namespace */

import PrototypeMap from "./prototypeMap";
import spearMarkerSvg from '../../svg/moisture-marker.svg';

/* eslint-enable import/no-unresolved, import/default, import/namespace */

export default angular.module('agrolog.farmer.measurementsMap', [])
    .directive('measurementsMap', MeasurementsMap)
    .name;

/*@ngInject*/
function MeasurementsMap () {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            device: "=",
            mapId: '<'
        },
        controller: MeasurementsMapController,
        controllerAs: 'vm'
    };
}
/* eslint-disable angular/angularelement */

/*@ngInject*/
function MeasurementsMapController($scope, $log, $element, $window,  types, toast, agTypes, attributeService) {// eslint-disable-line

    let vm = this;

    let deviceMapContainer;

    vm.getCurrentLocation = getCurrentLocation;

    vm.latestValuesSubscriptionOptions = {
        callbacks: {
            onDataUpdated: onDataUpdated,
            onDataUpdateError: onDataUpdateError,
            dataLoading: (subscription) => {
                vm.loading = subscription.loadingData;
            }
        },
        useDashboardTimewindow: false
    };

    $scope.$watch('vm.ctx', () => {
        if (vm.ctx) {
            reset();
            deviceMapContainer = angular.element('#' + vm.mapId, $element);
            addResizeListener(deviceMapContainer[0], () => { // eslint-disable-line no-undef
                if (vm.ctx.map) {
                    vm.ctx.map.resize();
                }
            });
        }
    });

    $scope.$watch('vm.device', (newValue) => {
        if (newValue) {
            reset();
            createLatestValuesSubscription();
        }
    });

    function createLatestValuesSubscription() {
        let latestValuesSubscriptionsInfo = [
            {
                type: types.datasourceType.entity,
                entityType: types.entityType.device,
                entityId: vm.device.id.id,
                entityName: vm.device.label,
                attributes: [
                    {name: 'latitude'},
                    {name: 'longitude'}
                ]
            }
        ];
        vm.ctx.subscriptionApi.createSubscriptionFromInfo(types.widgetType.latest.value, latestValuesSubscriptionsInfo, vm.latestValuesSubscriptionOptions, false, true).then(
            (subscription) => {
                vm.ctx.defaultSubscription = subscription;
                initMap();
            }
        )
    }

    function initMap() {
        let settings = {
            fitMapBounds: true,
            label: '<div style="position: relative; white-space: nowrap; text-align: center; font-size: 12px; top: 4px;"><span style="margin-left: -500%;"></span><span style="border: 2px solid #3498db; border-radius: 10px; color: #303c42; background-color: #fff; padding-left: 5px; padding-right: 5px; padding-top: 3px; padding-bottom: 3px;">${entityName}</span><span style="margin-right: -500%;"></span></div>',
            latKeyName: "latitude",
            lngKeyName: "longitude",
            mapProvider: "OpenStreetMap.Mapnik",
            markerImage: spearMarkerSvg,
            markerImageSize: 60,
            showLabel: true,
            showTooltip: false,
            useClusterMarkers: true,
            zoomOnClick: true,
            showCoverageOnHover: true,
            animate: true,
            maxClusterRadius: 80
        };
        vm.ctx.settings = settings;
        vm.ctx.map = new PrototypeMap('openstreet-map', false, vm.ctx, false, deviceMapContainer, "satellite", true);
        vm.ctx.map.update();
    }

    function getCurrentLocation() {
        if ($window.navigator.geolocation) {
            $window.navigator.geolocation.getCurrentPosition(
                (position) => {
                    let attributes = [];
                    attributes.push({key: 'latitude', value: position.coords.latitude});
                    attributes.push({key: 'longitude', value: position.coords.longitude});
                    attributeService.saveEntityAttributes(vm.device.id.entityType, vm.device.id.id, types.attributesScope.server.value, attributes);
                },
                () => {
                    toast.showError("Geolocation is blocked in your browser", angular.element("#device-map"),'top left');
                },
                {
                    enableHighAccuracy: true
                }
            );
        } else {
            toast.showError("Your browser doesn't support geolocation", angular.element("#device-map"),'top left');
        }
    }

    function onDataUpdated(subscription, apply) {
        if (vm.ctx.map) {
            vm.ctx.map.update();
            vm.ctx.map.resize();
        }
        if (apply) {
            $scope.$digest();
        }
    }

    function onDataUpdateError(subscription, e) {
        $log.error(e);
    }

    $scope.$on('$destroy', () => {
        reset();
    });

    function reset() {
        if (vm.ctx.defaultSubscription) {
            vm.ctx.subscriptionApi.removeSubscription(vm.ctx.defaultSubscription.id);
            vm.ctx.defaultSubscription = null;
            if (vm.ctx.map) {
                vm.ctx.map.removeMap();
            }
            vm.ctx.map = null;
        }
    }
}